import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import dayjs from '@material-ui/pickers/adapter/dayjs';
import { LocalizationProvider } from '@material-ui/pickers';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';

import { store } from 'store';
import isDesktop from 'helpers/isDesktop';
import ScrollToTop from 'helpers/scrollToTop';
import Main from 'sections/main';
import Popups from 'sections/popups';
import Dialogs from 'sections/dialogs';
import Toasters from 'sections/toasters';

function App() {
  return (
    <div className="main-wrapper">
      <div className={classNames('main-content', { desktop: isDesktop })}>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={dayjs}>
            <BrowserRouter>
              <ScrollToTop />
              <Main />
              <Popups />
              <Dialogs />
              <Toasters />
            </BrowserRouter>
          </LocalizationProvider>
        </Provider>
      </div>
    </div>
  );
}

export default App;
